import WithGASetup from '../../components/WithGASetup';
import AuthContext from '../../context/AuthContext';
import AsessmentPage from './AsessmentPage';

export default WithGASetup(AsessmentPage, AuthContext);
